import {useTranslation} from '@aboutyou/i18n';
import React from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {useTimedOut} from '../../../hooks/useManualTimeout/useManualTimeout';
import {Icon} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';

const ANIMATION_DURATION = 200;
const COLLAPSE_ANIMATION_DELAY = 5000;
const HIDE_ANIMATION_DELAY = 500;

export const ThanksForYourFeeback: React.FC = () => {
  const {t} = useTranslation();
  const isAnimationDone = useTimedOut(
    COLLAPSE_ANIMATION_DELAY + HIDE_ANIMATION_DELAY + ANIMATION_DURATION * 2,
  );

  if (isAnimationDone) {
    return null;
  }

  return (
    <Wrapper>
      <ThanksForYourFeebackIcon
        asset={GenericIconName.AlertSuccessFill}
        color={COLORS.White}
        fill={COLORS.Green}
      />
      <ThanksForYourFeebackLabel>
        {t('Thank you for your feedback!')}
      </ThanksForYourFeebackLabel>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 8px;
  height: 48px;
  font-size: ${FONT_SIZES.px14};
  background: ${COLORS.White};
  border-radius: 25px;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.08);

  transition: opacity 0.3s, transform 0.4s;
  animation: collapse ${ANIMATION_DURATION}ms cubic-bezier(0, 0.5, 1, 0.5)
      ${COLLAPSE_ANIMATION_DELAY}ms forwards,
    hide ${ANIMATION_DURATION}ms ease-in
      ${COLLAPSE_ANIMATION_DELAY + HIDE_ANIMATION_DELAY}ms forwards;

  // To faithfully reproduce the animations proposed on Figma, we need to animate the width of the container.
  // eslint-disable-next-line local-rules/css-layout-animation
  @keyframes collapse {
    0% {
      width: 200px;
    }

    90% {
      width: 38px;
      margin: 0;
    }

    100% {
      width: 48px;
      margin: 0;
    }
  }

  @keyframes hide {
    0% {
      transform: translate(0, 0);
      opacity: 1;
    }

    100% {
      transform: translate(40%, 0);
      opacity: 0;
    }
  }
`;

const ThanksForYourFeebackIcon = styled(Icon)`
  width: 32px;
  height: 32px;
`;

const ThanksForYourFeebackLabel = styled.span`
  overflow: hidden;
  white-space: nowrap;
  margin: 0 8px 0 4px;
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
`;
